import { IMO } from "./carriers.js";
/** Human-readable IMO names for staff UI (nav, invites, user lists). */
export const IMO_LABELS = {
    [IMO.PINNACLE]: "Pinnacle",
    [IMO.PREMIER_PRODUCERS_GROUP]: "PPG",
    [IMO.HEARTLAND]: "Heartland",
    [IMO.SMS]: "SMS",
};
export function imoLabel(imo) {
    if (!imo)
        return null;
    if (imo in IMO_LABELS)
        return IMO_LABELS[imo];
    return imo.replace(/_/g, " ");
}
export function staffRoleLabel(role, providerImo) {
    if (role === "ADMIN") {
        return { title: "Admin", subtitle: "Full dashboard access" };
    }
    if (role === "PROVIDER" || role === "PPG") {
        const org = imoLabel(providerImo ?? (role === "PPG" ? IMO.PREMIER_PRODUCERS_GROUP : null));
        return {
            title: "Provider",
            subtitle: org ? `${org} contract queue` : "Organization not assigned",
        };
    }
    if (role === "AGENT") {
        return { title: "Registered agent", subtitle: "Agent portal login" };
    }
    return { title: role ?? "Unknown", subtitle: null };
}
